export function isIframeInDocument(iframeId) {
	return Boolean(document.getElementById(iframeId));
}
